import * as v from "valibot";

import { rpcContract } from "../rpc";

export const unlockExclusiveHighlightRpcContract = rpcContract({
  name: "unlockExclusiveHighlight",
  paramsSchema: v.object({
    highlightId: v.string(),
    email: v.pipe(v.string(), v.email("Invalid email format")),
    handle: v.pipe(v.string(), v.minLength(3), v.maxLength(64)),
  }),
  resultSchema: v.object({
    discount: v.object({
      id: v.string(),
      title: v.string(),
      url: v.string(),
      teaser: v.nullable(v.string()),
      code: v.nullable(v.string()),
      thumbnail: v.nullable(v.string()),
      has_discount: v.boolean(),
      exclusive: v.boolean(),
      end_date: v.nullable(v.string()),
      priority: v.nullable(v.number()),
      promotion_brand: v.nullable(
        v.object({
          id: v.string(),
          name: v.string(),
          thumbnail: v.nullable(v.string()),
        }),
      ),
      promotion_file: v.nullable(
        v.object({
          id: v.string(),
          path: v.string(),
          thumbnail_path: v.nullable(v.string()),
          mime_type: v.nullable(v.string()),
        }),
      ),
    }),
  }),
});

export type UnlockExclusiveHighlightParams = v.InferOutput<
  (typeof unlockExclusiveHighlightRpcContract)["paramsSchema"]
>;
export type UnlockExclusiveHighlightResult = v.InferOutput<
  (typeof unlockExclusiveHighlightRpcContract)["resultSchema"]
>;
export type UnlockedDiscount = v.InferOutput<(typeof unlockExclusiveHighlightRpcContract)["resultSchema"]>["discount"];
